import { BigNumber } from 'ethers'
import { ABI } from '../../abi'
import {
  IArgDict,
  IEditionMintStrategy,
  IPrivateMintFunctionArgs,
  IPublicMintFunctionArgs
} from './IEditionMintStrategy'

class Decent721MintStrategy implements IEditionMintStrategy {
  getAbi() {
    return ABI.DCNT721A
  }
  getPublicMintFunctionName(): string {
    return 'mint'
  }
  getPublicMintFunctionArgsDict({
    currentWalletAddress,
    mintCount
  }: IPublicMintFunctionArgs): IArgDict[] {
    return [
      { name: 'to', value: currentWalletAddress },
      { name: 'numberOfTokens', value: mintCount }
    ]
  }

  getPresaleMintFunctionName(): string {
    return 'mintPresale'
  }

  getPresaleMintFunctionArgsDicts({
    currentWalletAddress,
    mintCount,
    maxPurchasablePerWallet,
    preSalePrice,
    merkleProof
  }: IPrivateMintFunctionArgs): IArgDict[] {
    return [
      { name: 'to', value: currentWalletAddress },
      {
        name: 'quantity',
        value: mintCount === '$QUANTITY' ? mintCount : BigNumber.from(mintCount) // '$QUANTITY' is used for Paper XYZ Payments,
      },
      { name: 'maxQuantity', value: BigNumber.from(maxPurchasablePerWallet) },
      { name: 'pricePerToken', value: BigNumber.from(preSalePrice) },
      { name: 'merkleProof', value: merkleProof || [] }
    ]
  }

  getMintTotalFunctionName(): string {
    return 'totalSupply'
  }
  getMintTotalArgs(): any[] | undefined {
    return undefined
  }
  getMintTotalsFromData(data: any): { totalMinted: number; presaleMinted: number } {
    return {
      totalMinted: data.toNumber(),
      // We have no way to get the total presaleMinted from the decent contracts,
      // and no way to actually set an overall presale limit. So we just use
      // totalMinted for both.
      presaleMinted: data.toNumber()
    }
  }
}

export default new Decent721MintStrategy()
